export const CLIENT_ID = '';
export const CLIENT_SECRET = '';
export const BRYTECAM_URL = '';
export const IMG_URL = '';
